import * as screens from '@core/layouts/components/menu/screens';
import Icon from '../../utility/icomoon';
import paths from '../../views/screens/Protocols/paths';
import permissions from '../../views/screens/Protocols/permissions';

export default [
  {
    id: 'protocol',
    title: 'console.consoleCatalog',
    icon: <Icon size={20} icon="List" />,
    permissions: [
      permissions.listProtocol,
      permissions.createProtocol,
      permissions.editProtocol,
      permissions.deleteProtocol
    ],
    iconName: 'List',
    navLink: paths.consolesList,
    screenId: screens.PROTOCOL_CATALOG
  }
];
